export default __webpack_public_path__ + "static/media/icon-warning-o.fe77486f.svg";